<div class="d-flex justify-content-between align-items-center mb-2">
    <h3 class="mb-0">Door Types</h3>
    <button mat-flat-button color="primary" (click)="openDoorTypeDialog()">Create Door Type</button>
</div>

<p class="text-muted small">
    Door types offered on Fire Doors survey forms, with an optional maintenance
    reminder schedule. System door types are built in &mdash; their schedule can be
    edited but they cannot be renamed or deleted. Drag rows to reorder.
</p>

<table
    mat-table
    [dataSource]="doorTypes"
    class="w-100"
    cdkDropList
    [cdkDropListData]="doorTypes"
    (cdkDropListDropped)="drop($event)"
>
    <ng-container matColumnDef="drag">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let doorType">
            <mat-icon class="door-type-drag-handle" cdkDragHandle>drag_indicator</mat-icon>
        </td>
    </ng-container>

    <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let doorType">
            {{ doorType.title }}
        </td>
    </ng-container>

    <ng-container matColumnDef="inspection_frequency_months">
        <th mat-header-cell class="hide-on-mobile" *matHeaderCellDef>Inspection Frequency</th>
        <td mat-cell class="hide-on-mobile" *matCellDef="let doorType">
            {{ doorType.inspection_frequency_months ? doorType.inspection_frequency_months + ' month(s)' : 'No maintenance schedule' }}
        </td>
    </ng-container>

    <ng-container matColumnDef="notify_days_before">
        <th mat-header-cell class="hide-on-mobile" *matHeaderCellDef>Notify Before</th>
        <td mat-cell class="hide-on-mobile" *matCellDef="let doorType">
            {{ doorType.notify_days_before !== null ? doorType.notify_days_before + ' day(s)' : '—' }}
        </td>
    </ng-container>

    <ng-container matColumnDef="default">
        <th mat-header-cell class="hide-on-mobile" *matHeaderCellDef>Type</th>
        <td mat-cell class="hide-on-mobile" *matCellDef="let doorType">
            <span class="badge rounded-pill" [class.bg-secondary]="doorType.is_system" [class.bg-primary]="!doorType.is_system">
                {{ doorType.is_system ? 'System' : 'Custom' }}
            </span>
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let doorType">
            <button mat-button (click)="openDoorTypeDialog(doorType)">
                {{ doorType.is_system ? 'Edit Settings' : 'Edit' }}
            </button>
            @if (!doorType.is_system) {
                <button mat-button color="warn" (click)="confirmDelete(doorType)">Delete</button>
            }
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row"></tr>
    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" style="text-align: center;" colspan="6">
            {{ isLoading ? 'Loading...' : 'No door types found.' }}
        </td>
    </tr>
</table>
